import { useQuery } from '@tanstack/react-query';
import { useErrorMonitor, useHttpClient } from '@wix/fe-essentials-standalone';
import { LocaleDataTranslations } from '@common/types';

const useLocaleDataTranslation = ({
  staticLocaleUrl,
  language,
}: {
  staticLocaleUrl: string;
  language: string;
}) => {
  const httpClient = useHttpClient();
  const errorMonitor = useErrorMonitor();

  const getLocaleDataTranslation =
    async (): Promise<LocaleDataTranslations> => {
      try {
        const { data } = await httpClient.post<{
          localeDataTranslations: LocaleDataTranslations;
        }>('/localeDataTranslation/api', {
          staticLocaleUrl,
          language,
        });

        return data?.localeDataTranslations;
      } catch (e) {
        errorMonitor.captureException(e as Error);
        return {};
      }
    };

  const query = useQuery({
    queryKey: ['localeDataTranslation', staticLocaleUrl, language],
    queryFn: getLocaleDataTranslation,
    enabled: !!(staticLocaleUrl && language),
  });

  return {
    localeDataTranslations: query.data ?? {},
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useLocaleDataTranslation;
